<template>
  <div>
    <b-modal
      centered
      id="modal-add-house"
      hide-footer
      header-class="no-border"
      body-class="no-border"
      modal-class="modalStyle"
      ref="modal-add-house"
    >
      <div class="modalBody">
        <b-row class="formsArea">
          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Nome da Casa</label>
            <b-form-input
              type="text"
              v-model="house.name"
              aria-describedby="input-1-live-feedback"
              :state="validateState('name')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback"
              >Campo obrigatório</b-form-invalid-feedback
            >
          </b-form>

          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Código da Casa</label>
            <b-form-input
              type="text"
              v-model="house.code"
              aria-describedby="input-2-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="input-2-live-feedback"
              >Campo obrigatório</b-form-invalid-feedback
            >
          </b-form>
          <b-form @submit.prevent="handleSubmit">
            <label class="mt-3 labels">Composto da Casa</label>
            <b-form-select
              v-model="house.compound_id"
              :options="compounds"
              value-field="id"
              text-field="compound_number"
            >
            </b-form-select>
          </b-form>
        </b-row>
      </div>

      <div class="modalFooter">
        <b-row class="alinhamentoLinha">
          <b-button class="button btn-cancel" @click="handleSubmit(false)"
            >Cancelar</b-button
          >
          <b-button
            class="button btn-save"
            type="submit"
            variant="primary"
            @click="handleSubmit(true)"
            >Salvar</b-button
          >
        </b-row>
      </div>
    </b-modal>
    <ModalConfirmation
      :isConfirm="isConfirm"
      @responseModal="responseModal($event)"
      :house="house"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import ModalConfirmation from '../ModalConfirmation.vue';
import { AddHouse } from '../../services/House';
import { Compounds } from '../../services/Compound';
import showError from '../../utils/showError';

export default {
  mixins: [validationMixin],
  data() {
    return {
      isConfirm: true,
      compounds: [],
      house: {
        name: '',
        code: '',
        compound_id: '',
      },
    };
  },
  validations: {
    house: {
      name: {
        required,
      },
    },
  },
  created() {
    Compounds().then((response) => {
      response.data.forEach((compound) => {
        if (!compound.is_discarded) {
          this.compounds.push(compound);
        }
      });
    });
  },
  methods: {
    handleSubmit(isConfirm) {
      if (isConfirm) {
        this.$v.house.$touch();
        if (this.$v.house.$anyError) return;
      }
      this.openModal(isConfirm);
    },
    openModal(isConfirm) {
      this.isConfirm = isConfirm;
      this.$bvModal.show('modal-confirmation');
    },
    responseModal(event) {
      if (event) {
        const data = {
          house_name: this.house.name,
          house_code: this.house.code,
        };
        if (this.house.compound_id) data.compound_id = this.house.compound_id;

        AddHouse(data)
          .then(() => {
            this.$bvModal.hide('modal-add-house');
            this.$bvModal.hide('modal-confirmation');
            this.$toasted.global.defaultSuccess();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch(showError);
      }
      this.resetForm();
      this.$bvModal.hide('modal-add-house');
      this.$bvModal.hide('modal-confirmation');
    },
    resetForm() {
      this.$v.$reset();
      this.house.name = '';
      this.house.code = '';
      this.house.compound_id = '';
    },
    validateState(type) {
      const { $dirty, $error } = this.$v.house[type];
      return $dirty ? !$error : null;
    },
  },
  components: { ModalConfirmation },
};
</script>

<style lang="scss" scoped>
::v-deep .no-border {
  border: none;
}
::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #be8250;
  border-radius: 20px;
  color: #eeeeee;
}

.cursor {
  cursor: pointer;
}

.custom-select {
  background-color: #eeeeee;
  border-radius: 11px;
  width: 350px;
  display: flex;
}
.modalBody {
  font-family: 'Inter', sans-serif;
  //   display: grid;
  //   grid-template-columns: 1fr 2fr;
  //   grid-gap: 20px;
}
.modalFooter {
  margin-top: 30px;
}
.alinhamentoLinha {
  display: flex;
  justify-content: flex-end;
  margin-right: 0.5rem !important;
}
.cursor {
  cursor: pointer;
}

.horizontal-inputs {
  margin-bottom: 20px;
}

.formsArea {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
}
.form-control {
  background-color: #eeeeee;
  border-radius: 11px;
  width: 350px;
}

.modalFooter {
  margin-top: 30px;
}
.alinhamentoLinha {
  display: flex;
  justify-content: flex-end;
  margin-right: 0.5rem !important;
}
.button {
  height: 32px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 22px;
  border: none;
  width: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
.btn-cancel {
  background-color: #d12c38;
}
.btn-save {
  background-color: #169933;
  margin-left: 18px;
}
</style>
